import BorderBox from './BorderBox.component';

export default BorderBox;
